import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col, Badge, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSave,
    faTimes,
    faPlus,
    faCalendarAlt,
    faClock,
    faFlag,
    faUser,
    faTags,
    faLink,
    faAlignLeft,
    faEdit
} from '@fortawesome/free-solid-svg-icons';

import { supabaseDataService } from '../services/supabaseService';

const TaskModal = ({ show, onHide, task, onSave, uid }) => {
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        category: '',
        priority: 'medium',
        due_date: '',
        status: 'pending',
        estimated_time: '',
    });

    const [tagInput, setTagInput] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (task) {
            // Editing existing task
            setFormData({
                title: task.title || '',
                description: task.description || '',
                category: task.category || '',
                priority: task.priority || 'medium',
                due_date: task.due_date || '',
                status: task.status || 'pending',
                estimated_time: task.estimated_time ? task.estimated_time.toString() : '',
            });
        } else {
            // Creating new task
            setFormData({
                title: '',
                description: '',
                category: '',
                priority: 'medium',
                due_date: '',
                status: 'pending',
                estimated_time: '',
            });
        }
        setTagInput('');
        setError('');
    }, [task, show]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAddTag = () => {
        if (tagInput.trim() && !formData.tags.includes(tagInput.trim())) {
            setFormData(prev => ({
                ...prev,
                tags: [...prev.tags, tagInput.trim()]
            }));
            setTagInput('');
        }
    };

    const handleRemoveTag = (tagToRemove) => {
        setFormData(prev => ({
            ...prev,
            tags: prev.tags.filter(tag => tag !== tagToRemove)
        }));
    };

    const handleTagInputKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAddTag();
        }
    };

    const validateForm = () => {
        if (!formData.title.trim()) {
            setError('Title is required');
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        try {
            setLoading(true);
            setError('');

            const taskData = {
                ...formData,
                uid: uid,
                estimated_time: formData.estimated_time ? parseInt(formData.estimated_time) : null
            };


            console.log('taskData----->',taskData);

            let savedTask;
            if (task) {
                // Update existing task
                savedTask = await supabaseDataService.updateTask(task.task_id, taskData);
            } else {
                // Create new task
                savedTask = await supabaseDataService.createTask(taskData);
            }

            onSave(savedTask);
            onHide();
        } catch (err) {
            setError('Failed to save task. Please try again.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const categories = [
        'development',
        'design',
        'testing',
        'documentation',
        'meeting',
        'research',
        'bug-fix',
        'feature',
        'maintenance'
    ];

    const priorities = [
        { value: 'low', label: 'Low', variant: 'success' },
        { value: 'medium', label: 'Medium', variant: 'warning' },
        { value: 'high', label: 'High', variant: 'danger' }
    ];

    const statuses = [
        { value: 'pending', label: 'Pending', variant: 'warning' },
        { value: 'in progress', label: 'In Progress', variant: 'primary' },
        { value: 'completed', label: 'Completed', variant: 'success' },
        { value: 'blocked', label: 'Blocked', variant: 'danger' }
    ];

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FontAwesomeIcon
                        icon={task ? faEdit : faPlus}
                        className="me-2"
                    />
                    {task ? 'Edit Task' : 'Create New Task'}
                </Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    {error && (
                        <Alert variant="danger" className="mb-3">
                            {error}
                        </Alert>
                    )}

                    <Row className="mb-3">
                        <Col>
                            <Form.Group>
                                <Form.Label>
                                    <FontAwesomeIcon icon={faAlignLeft} className="me-2" />
                                    Title *
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="title"
                                    value={formData.title}
                                    onChange={handleInputChange}
                                    placeholder="Enter task title"
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col>
                            <Form.Group>
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    placeholder="Enter task description"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        {/*<Col md={6}>*/}
                        {/*    <Form.Group>*/}
                        {/*        <Form.Label>*/}
                        {/*            <FontAwesomeIcon icon={faTags} className="me-2" />*/}
                        {/*            Category*/}
                        {/*        </Form.Label>*/}
                        {/*        <Form.Select*/}
                        {/*            name="category"*/}
                        {/*            value={formData.category}*/}
                        {/*            onChange={handleInputChange}*/}
                        {/*        >*/}
                        {/*            <option value="">Select category</option>*/}
                        {/*            {categories.map(category => (*/}
                        {/*                <option key={category} value={category}>*/}
                        {/*                    {category.charAt(0).toUpperCase() + category.slice(1)}*/}
                        {/*                </option>*/}
                        {/*            ))}*/}
                        {/*        </Form.Select>*/}
                        {/*    </Form.Group>*/}
                        {/*</Col>*/}
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>
                                    <FontAwesomeIcon icon={faFlag} className="me-2" />
                                    Priority
                                </Form.Label>
                                <Form.Select
                                    name="priority"
                                    value={formData.priority}
                                    onChange={handleInputChange}
                                >
                                    {priorities.map(priority => (
                                        <option key={priority.value} value={priority.value}>
                                            {priority.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Status</Form.Label>
                                <Form.Select
                                    name="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                >
                                    {statuses.map(status => (
                                        <option key={status.value} value={status.value}>
                                            {status.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        {/*<Col md={6}>*/}
                        {/*    <Form.Group>*/}
                        {/*        <Form.Label>*/}
                        {/*            <FontAwesomeIcon icon={faUser} className="me-2" />*/}
                        {/*            Assigned To*/}
                        {/*        </Form.Label>*/}
                        {/*        <Form.Control*/}
                        {/*            type="text"*/}
                        {/*            name="assigned_to"*/}
                        {/*            value={formData.assigned_to}*/}
                        {/*            onChange={handleInputChange}*/}
                        {/*            placeholder="Enter assignee name"*/}
                        {/*        />*/}
                        {/*    </Form.Group>*/}
                        {/*</Col>*/}
                    </Row>

                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>
                                    <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                                    Due Date
                                </Form.Label>
                                <Form.Control
                                    type="date"
                                    name="due_date"
                                    value={formData.due_date}
                                    onChange={handleInputChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>
                                    <FontAwesomeIcon icon={faClock} className="me-2" />
                                    Estimated Time (minutes)
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    name="estimated_time"
                                    value={formData.estimated_time}
                                    onChange={handleInputChange}
                                    placeholder="e.g., 120 for 2 hours"
                                    min="0"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/*<Row className="mb-3">*/}
                    {/*    <Col>*/}
                    {/*        <Form.Group>*/}
                    {/*            <Form.Label>*/}
                    {/*                <FontAwesomeIcon icon={faTags} className="me-2" />*/}
                    {/*                Tags*/}
                    {/*            </Form.Label>*/}
                    {/*            <div className="d-flex mb-2">*/}
                    {/*                <Form.Control*/}
                    {/*                    type="text"*/}
                    {/*                    value={tagInput}*/}
                    {/*                    onChange={(e) => setTagInput(e.target.value)}*/}
                    {/*                    onKeyPress={handleTagInputKeyPress}*/}
                    {/*                    placeholder="Add a tag and press Enter"*/}
                    {/*                    className="me-2"*/}
                    {/*                />*/}
                    {/*                <Button*/}
                    {/*                    variant="outline-primary"*/}
                    {/*                    onClick={handleAddTag}*/}
                    {/*                    disabled={!tagInput.trim()}*/}
                    {/*                >*/}
                    {/*                    <FontAwesomeIcon icon={faPlus} />*/}
                    {/*                </Button>*/}
                    {/*            </div>*/}
                    {/*            <div>*/}
                    {/*                {formData.tags.map((tag, index) => (*/}
                    {/*                    <Badge*/}
                    {/*                        key={index}*/}
                    {/*                        bg="secondary"*/}
                    {/*                        className="me-1 mb-1"*/}
                    {/*                        style={{ cursor: 'pointer' }}*/}
                    {/*                        onClick={() => handleRemoveTag(tag)}*/}
                    {/*                    >*/}
                    {/*                        {tag} <FontAwesomeIcon icon={faTimes} className="ms-1" />*/}
                    {/*                    </Badge>*/}
                    {/*                ))}*/}
                    {/*            </div>*/}
                    {/*        </Form.Group>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}

                    {/*<Row className="mb-3">*/}
                    {/*    <Col>*/}
                    {/*        <Form.Group>*/}
                    {/*            <Form.Label>*/}
                    {/*                <FontAwesomeIcon icon={faLink} className="me-2" />*/}
                    {/*                Dependencies*/}
                    {/*            </Form.Label>*/}
                    {/*            <Form.Control*/}
                    {/*                type="text"*/}
                    {/*                name="dependencies"*/}
                    {/*                value={formData.dependencies}*/}
                    {/*                onChange={handleInputChange}*/}
                    {/*                placeholder="List any task dependencies"*/}
                    {/*            />*/}
                    {/*        </Form.Group>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide} disabled={loading}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" />
                                Saving...
                            </>
                        ) : (
                            <>
                                <FontAwesomeIcon icon={faSave} className="me-2" />
                                {task ? 'Update Task' : 'Create Task'}
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default TaskModal;